import React, { memo, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import { AnalyticsService, PaymentService } from "@propertelligent/client-api";
import PieChart from "./expenseDistribution";
import Transactions from "./transactions";
import { useAnalyticsHook } from "../../../hooks/useAnalyticsHook";
import { usePaginationHook } from "../../../hooks/usePaginationHook";
import { UserLoginData } from "../../common/charts/Enums";
import SuccessAlert from "../../tenants/SuccessAlert";
import { GetImages } from "../../../utils/GetImages";

const Overview = ({
  paymentMethodsArr,
  payeeAccountsArr,
  entityTypeId,
  loadingStates,
  setLoadingStates,
}) => {
  const { id } = useParams();
  const [showModel, setShowModel] = useState(false);
  const [rev_monthValue, setRev_MonthValue] = useState(-12);
  const [fin_monthValue, setFin_MonthValue] = useState(-12);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const { singleProperty } = useSelector((state: any) => state.singleProperty);

  const customMonthField = "monthYear";
  const { cashFlow, expensebycategoryArr, fetchAndFormatExpensebycategory } =
    useAnalyticsHook({
      httpExpensebycategoryFn:
        AnalyticsService.getApiAnalyticsPropertyExpensebycategory,
      httpCashflowFn: AnalyticsService.getApiAnalyticsPropertyCashflow,
      customMonthField,
      parentEntityId: Number(id),

      fullyQualifiedFilters: {
        rev: `Created>DateTime.UtcNow.AddMonths(${rev_monthValue})`,
        fin: `Created>DateTime.UtcNow.AddMonths(${fin_monthValue})`,
      },
    });

  const {
    loading,
    rows,
    rowCount,
    fetchData,
    CustomPagination,
    handleSortModelChange,
    handleFilterModelChange,
    handlePaginationModelChange,
  } = usePaginationHook({
    httpFetchDataFn: PaymentService.getApiPaymentDueAccountPropertylist,
    paginationDataMapper: null,
    parentEntityId: Number(id),
    isDependentEntity: true,
    FullyQualifiedFilters: null,
  });

  useMemo(() => {}, [
    fin_monthValue,
    rev_monthValue,
    expensebycategoryArr?.length,
  ]);
  useEffect(() => {}, [rows?.length]);

  useEffect(() => {
    if (!loading && cashFlow && expensebycategoryArr) {
      setLoadingStates({
        ...loadingStates,
        overview: false,
      });
    }
  }, [loading, expensebycategoryArr, expensebycategoryArr]);

  const { totalExpense, totalRevenue, netProfit } = cashFlow.reduce(
    (accumulator, current) => {
      accumulator.totalExpense += current.expense || 0;
      accumulator.totalRevenue += current.income || 0;
      return accumulator;
    },
    { totalExpense: 0, totalRevenue: 0, netProfit: 0 }
  );

  // const handleSubmitPaymentAccountRecord = (data) => {
  //   const organizationId = parseInt(
  //     localStorage.getItem(UserLoginData.organization_id)
  //   );
  //   Object.assign(data.values, {
  //     organizationId,
  //     entityTypeId: entityTypeId,
  //     dueDate: new Date(data.values?.dueDate).toISOString(),
  //   });

  //   if (data.values.paymentDueAccountStatusId === 2) {
  //     PaymentService.postApiPaymentDueAccount(data.values)
  //       .then((res: any) => {
  //         if (res?.success) {
  //           Object.assign(data.payvalues, {
  //             payDueAccountId: res?.success.id,
  //           });

  //           PaymentService.putApiPaymentDueAccountPay(data.payvalues)
  //             .then((res: any) => {
  //               if (res?.success) {
  //                 setShowModel(false);
  //                 setShowSuccessAlert(true);
  //                 setTimeout(() => {
  //                   setShowSuccessAlert(false);
  //                 }, 3000);
  //                 fetchData();
  //                 fetchAndFormatExpensebycategory();
  //               }
  //             })
  //             .catch((error) => { });
  //         }
  //       })
  //       .catch((error) => { });
  //   } else if (data.values.paymentDueAccountStatusId === 1) {
  //     PaymentService.postApiPaymentDueAccount(data.values)
  //       .then((res: any) => {
  //         if (res?.success) {
  //           fetchData();
  //           fetchAndFormatExpensebycategory();
  //           setShowModel(false);

  //           setShowSuccessAlert(true);
  //           setTimeout(() => {
  //             setShowSuccessAlert(false);
  //           }, 3000);
  //         }
  //       })
  //       .catch((error) => { });
  //   }
  // };

  const expensedata = [
    {
      id: 1,
      name: "Net Profit",
      value: totalRevenue - totalExpense,
      boxclass: "blueBox",
    },
    { id: 2, name: "Expense", value: totalExpense, boxclass: "orangeBox" },
  ];

  return (
    <>
      <div className="overview-details-container  ">
        <div className="overviewfirst">
          <div className="overviewfirstright">
            <div className="overviewfirstrightfirst">
              <div>
                <div className="CommonRoundBackground BackgroundlightOrange">
                  <img src={GetImages.OrangeDoller} className="Icon20" />
                </div>
              </div>
              <div className="incomeExpense ">
                <div className="commonbox">
                  <p className="FW700_LH24_main_text">
                    ${singleProperty?.formatted?.IncomeDue}
                  </p>
                  <p className="FW400_LH16_small_text">Income due</p>
                </div>
                <div className="dividerdiv"></div>
                <div className="commonbox">
                  <p className="FW700_LH24_main_text">
                    ${singleProperty?.formatted?.ExpensesDue}
                  </p>
                  <p className="FW400_LH16_small_text">Expense due</p>
                </div>
              </div>
            </div>

            <div className="overviewfirstrightsecond">
              <div className="firstbox">
                <div className="CommonRoundBackground BackgroundlightOrange">
                  <img src={GetImages.OrangeUnit} className="Icon20" />
                </div>

                <div className="commonbox">
                  <p className="FW700_LH24_main_text">
                    {singleProperty?.vacantUnits}
                  </p>
                  <p className="FW400_LH16_small_text">Vacant Units</p>
                </div>
              </div>
            </div>
            <div className="overviewfirstrighthird">
              <div className="firstbox">
                <div className="CommonRoundBackground BackgroundlightOrange">
                  <img src={GetImages.OrangeList} className="Icon20" />
                </div>
                <div className="commonbox">
                  <p className="FW700_LH24_main_text">
                    {singleProperty?.openServiceRequests}
                  </p>
                  <p className="FW400_LH16_small_text">Open service requests</p>
                </div>
              </div>
            </div>
          </div>
          <div className="overviewfirstleft">
            <div className="overviewfirstleftfirst">
              <p className="FW700_LH24_main_text">Revenue Overview</p>

              <div className="monthhead ">
                <button
                  onClick={() => setRev_MonthValue(-1)}
                  className={
                    rev_monthValue === -1
                      ? "overviewSelectedButton"
                      : "overviewUnselectedButton"
                  }
                >
                  Last month
                </button>
                <button
                  onClick={() => setRev_MonthValue(-6)}
                  className={
                    rev_monthValue === -6
                      ? "overviewSelectedButton"
                      : "overviewUnselectedButton"
                  }
                >
                  Last 6 month
                </button>
                <button
                  onClick={() => setRev_MonthValue(-12)}
                  className={
                    rev_monthValue === -12
                      ? "overviewSelectedButton"
                      : "overviewUnselectedButton"
                  }
                >
                  Last 12 Months
                </button>
              </div>
            </div>

            <div className="overviewfirstleftsecond">
              <div className="revenueleft">
                {expensedata?.map((item, index) => (
                  <React.Fragment key={item.id}>
                    <div className="netprofit-expesnse">
                      <div className="netprofit-expesnse-first ">
                        <div className="propertyCardQuantityDesc ">
                          <div className={item.boxclass}></div>
                          <p className="FW400_LH20_small_text ">{item.name}</p>
                        </div>
                        <p className="FW700_LH24_main_text">$ {item.value}</p>
                      </div>
                    </div>
                    {index !== expensedata.length - 1 && (
                      <div className="dividerdiv"></div>
                    )}
                  </React.Fragment>
                ))}
              </div>
              <div className="revenueright">
                <div
                  style={
                    {
                      "--percentage":
                        ((totalRevenue - totalExpense) / totalRevenue) * 100,
                    } as React.CSSProperties
                  }
                  className="semi-donut margin"
                >
                  <div className="RevenueOverviewHalfDoughnut">
                    <p className="FW700_LH24_main_text">$ {totalRevenue}</p>
                    <p className="FW400_LH16_small_text">Total Revenue</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="financeHeading">
          <p className="FW700_LH24_main_text">Finance Overview</p>
        </div>
        <div className="financeOverview">
          <PieChart
            fin_monthValue={fin_monthValue}
            setFin_MonthValue={setFin_MonthValue}
            data={expensebycategoryArr}
          />
          <div className="transactions">
            <div className="transactionheader">
              <p className="FW700_LH24_main_text">Last 5 Transactions</p>
            </div>
            <Transactions
              rows={rows}
              sorting="last-five"
              paymentMethodsArr={paymentMethodsArr}
              fetchData={fetchData}
              fetchAndFormatExpensebycategory={fetchAndFormatExpensebycategory}
            />
          </div>
        </div>
        {showSuccessAlert && (
          <SuccessAlert
            message={"Payment Added Successfully"}
            setShowSuccessAlert={setShowSuccessAlert}
          />
        )}
      </div>
    </>
  );
};

export default memo(Overview);
